import {
  GetElectronicMail,
  ReloadElectronicMail,
} from "../popconfirm-electronic-mail/download/buttons";
import { useContext, useEffect, useMemo, useState } from "react";

import ArrowDownOutlined from "@ant-design/icons/ArrowDownOutlined";
import ArrowUpOutlined from "@ant-design/icons/ArrowUpOutlined";
import Button from "antd/lib/button";
import CheckboxGroup from "../checkbox-group";
import DatePickers from "../datapickers";
import Directories from "../../directories";
import DirectoriesForm from "../../forms/directories";
import { DocumentsButtonsProps } from "./types";
import DocumentsEditForm from "../../forms/documents/edit";
import DocumentsForm from "../../forms/documents/add";
import Dropdown from "antd/lib/dropdown";
import DropdownButtons from "../dropdown-buttons";
import { FormContext, FormProvider } from "../../../contexts/form/index.context";
import FormRef from "antd/lib/form";
import type { MenuProps } from "antd/es/menu/menu";
import Modal from "../modal";
import { ModalContext } from "../../../contexts/modal/index.context";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import Popconfirm from "../popconfirm";
import PopconfirmSendElectronicMail from "../popconfirm-electronic-mail/send";
import RadioGroup from "../radio-group";
import SaveFiles from "../file-editor/save-files";
import Select from "../select";
import SignModal from "../sign-modal";
import Space from "antd/lib/space";
import { SubSessionContext } from "../../../contexts/session-sub/index.context";
import Tooltip from "antd/lib/tooltip";
import { TranslationContext } from "../../../contexts/translation/index.context";
import VerticalAlignBottomOutlined from "@ant-design/icons/VerticalAlignBottomOutlined";
import VerticalAlignTopOutlined from "@ant-design/icons/VerticalAlignTopOutlined";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import {wrapperDynamicRoutes} from "../../../helpers/dynamic-routes-menu";
import { TableContext } from "../../../contexts/table/index.context";
// import { Positions } from "../../forms/directories/utils/form-items/directories/hr-department";

// import type {  SelectedExecutorsTable } from "../table/utils/types/directories/document-characteristics";


//Components
//UI
//Icons

// Компонент глобальний виводить кнопки та алфавіт для сортування

export default function DocumentsButtonsComponent(
  props: DocumentsButtonsProps
) {
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { disabled } = useContext(ModalContext);
  const { sessionDataSub } = useContext(SubSessionContext);
  const pathname = props.url || location.pathname;
    const { activeModal } = useContext(ModalContext);
      const { form } = useContext(FormContext);
  const { rowData, contextTableData, setContextTableData } = useContext(TableContext);
    
  
  // const fromName = crypto.randomUUID();
  /**
   * Визначаємо назву форми в залежності від того, чи є URL порожнім.
   * Якщо URL порожній, то використовуємо "main", інакше - "modal".
   * Це може бути корисно для ідентифікації форми в контексті застосунку.
   */
  const formName = !props.url ? "main":"modal";

  const isDocuments =
    location.pathname.split("/")[1].includes("documents") &&
    !props.url?.includes("directories");
  const isDiscussion = props.url === "/directories/discussion";
  const isIncomingEmail = pathname === "/directories/incoming-email";
  const isNomenclatureOfCases =
    pathname === "/directories/nomenclature-of-cases";
  const isCheckboxGroup =
    pathname === "/directories/employees-and-contact-persons" ||
    pathname === "/directories/types-of-documents";
  const isRadioGroup = pathname === "/directories/structural-units";
  const isForResolutions = pathname === "/documents/resolutions";
  const isForSignature = pathname === "/documents/for-signature";
  const isForEmail = pathname === "/documents/electronic-mail";
  const isForSubEmail = pathname === "/documents/electronic-mail/getfiles";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isStructuralUnits = props.url === "/directories/structural-units" && !activeModal;
  // const [isDynamicRoute, setIsDynamicRoute] = useState(false);

  // const isProfilePath = props.url === "/profile/menu-tabs";


  // Компонент Карта маршрутів для перевірки дії на кнопці
  // const btnNamesMap = {
  //   '/documents/incoming/add': {
  //     add: 'stock-add'
  //   },
  //   '/documents/incoming/edit': {
  //     edit: 'stock-edit'
  //   },
  // }

  // чи ховати кнопку "додати" саме на цьому маршруті
  const [shouldHideAddHere, setShouldHideAddHere] = useState(false);



  useEffect(() => {
    (async () => {
      let showBtn = await wrapperDynamicRoutes(location.pathname)
      // console.log("boolean ", showBtn)
      setShouldHideAddHere(showBtn)
    })();
  }, [location.pathname]);


  // useEffect(() => {
  //   // console.log("Modal props ", props);
  // }, [isModalOpen]);

  // console.log("URL PopconfirmComponent1 ", props.url);
  const formComponent = isDocuments ? (
    <DocumentsForm url={props.url} />
  ) : (
    <DirectoriesForm
      url={props.url}
      id={props.id}
      setIsShowModal={setIsModalOpen}
    />
  );
  const editFormComponent = (
    <DocumentsEditForm url={pathname} isForSignature={isForSignature}/>
  );

  // const positionButtons: {
  //   [key: string]: { icon: JSX.Element; tooltip: string };
  // } = {
  //   "to-first": { icon: <VerticalAlignTopOutlined />, tooltip: "to-first" },
  //   "to-previous": { icon: <ArrowUpOutlined />, tooltip: "to-previous" },
  //   "to-next": { icon: <ArrowDownOutlined />, tooltip: "to-next" },
  //   "to-last": { icon: <VerticalAlignBottomOutlined />, tooltip: "to-last" },
  // };



  const modalItems =
    pathname === "/directories/employees-and-contact-persons"
      ? ["contact-person", "employee"]
      : pathname === "/directories/passing"
      ? ["add-an-action-for-one-performer", "add-an-action-from-a-template"]
      : ["add", "edit"];

  // Код для видалення з потрібної таблиці
  let rowData_;
  let updateUrl = props.url;
  if (pathname === "/directories/employees-and-contact-persons") {
    try {
      rowData_ = JSON.parse(
        sessionStorage.getItem(
          "session_data_/directories/employees-and-contact-persons"
        ) || "null"
      );
    } catch (e) {
      rowData_ = null;
    }

    const isEmployee = rowData_?.is_clerk === 1;
    updateUrl =
      pathname === "/directories/employees-and-contact-persons"
        ? `${pathname}/${isEmployee ? "employee" : "contact-person"}`
        : props.url;
  }
  const dropdown = (
    <Dropdown
      className={styles["dropdown"]}
      menu={{
        items: modalItems.map((name) => ({
          key: name,
          label: (
            <div key={name}>
              <Modal url={props.url} name={name} width={700}>{formComponent}</Modal>
            </div>
          ),
        })),
      }}
      trigger={["click"]}
      placement="bottomLeft"
    >
      <Button className={styles["button"]} icon={<PlusOutlined />}/>
    </Dropdown>
  );

  const extraButtons: Partial<Record<string, JSX.Element>> = {
    showAddButton: (
      <Modal
        name="add"
        isShowModal={isModalOpen}
        setIsShowModal={isDocuments ? undefined : setIsModalOpen}
        url={pathname}
        width={700}
      >
        {formComponent}
      </Modal>
    ),
    showEditeButton: (
      <Modal
        name="edit"
        isShowModal={isModalOpen}
        setIsShowModal={isDocuments ? undefined : setIsModalOpen}
        isEdit={isDocuments}
        url={pathname}
        width={isDocuments ? "auto" : 700}
      >
        {isDocuments ? editFormComponent : formComponent}
      </Modal>
    ),
    isForEmail: (
      <div className="emailIconsStyle" style={{width: "70px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center"}}>
        <PopconfirmSendElectronicMail sendAll={false} />
        <PopconfirmSendElectronicMail sendAll={true} />
      </div>
    ),
    isIncomingEmail: (
      <>
        <ReloadElectronicMail />
        <Popconfirm url={props.url} />
        <div style={{display: "flex"}}>
          <GetElectronicMail documentsId={props.id} />
          <DatePickers url="/directories/incoming-email" />
        </div>
      </>
    ),
    isForSubEmail: (
      <SaveFiles
        selectedFiles={[sessionDataSub.id]}
        bta_documents_id={sessionDataSub.bta_documents_id}
      />
    ),
    showDeleteButton: <Popconfirm url={updateUrl} />,
    isDocuments: <DropdownButtons intl={intl} url={pathname} />,
    // Додавай інші кнопки при потребі
  };
  const flags = {
    showAddButton: ( !isForResolutions && !isForSignature && !isForEmail && !isForSubEmail && !isIncomingEmail && !shouldHideAddHere) && !isStructuralUnits,
    showEditeButton: ( props.url !== "/directories/resolution-templates/executors" &&  !isForEmail && !isForSubEmail && !isIncomingEmail && !isStructuralUnits),
    isForEmail,
    isIncomingEmail,
    isForSubEmail,
    isDocuments: isDocuments && !isForSubEmail,
    showDeleteButton: !isDocuments && !isDiscussion && !isIncomingEmail && !isStructuralUnits,
    // isForSignature,
    // isRadioGroup,
    // isCheckboxGroup,
    // isNomenclatureOfCases,
    // Додай інші прапори тут
  };
  const ignoredButtons = ["showAddButton"];

  // const updatePosition = async (type: string) => {
  //   if (
  //     (type === "to-first" || type === "to-previous") &&
  //     rowData.executors?.num_pp === 1
  //   )
  //     return;
  //   if (
  //     (type === "to-last" || type === "to-next") &&
  //     rowData.executors?.num_pp === data.executors.length
  //   )
  //     return;
  //   await request(
  //     `${props.url || location.pathname}/updateresolutionexecutors`,
  //     {
  //       method: "post",
  //       body: {
  //         id: rowData.templates?.id,
  //         rowId: rowData.executors?.id,
  //         numPP: rowData.executors?.num_pp,
  //         recordCount: data.executors.length,
  //         type,
  //       },
  //       cancelTokenKey: "updateresolutionexecutors",
  //     }
  //   );
  //   await fetchData("executors");
  //   await fetchData("templates");
  //   setSelectedRow((prev) => ({ ...prev, executors: undefined }));
  // };

    type PositionKey = 'to-first' | 'to-previous' | 'to-next' | 'to-last';
    const positionsSelector = {first: 'to-first', previous: 'to-previous', next: 'to-next', last: 'to-last'};
    
  interface PositionButtonCfg {
    icon: JSX.Element;
    tooltip: string;
    onClick: () => void;         // <- функція
  }

  type Item = {
    id: number;
    key: string;
    tableId: number;
    num_pp: number;
    resolutionId: number,
    selectedRowKeys: number;
    url: string;
    ExecutorFIO: string;
    clerksId: number;
    contactPersonId: any;
  };


  // type SessionRow = Record<string, {data: Item}> | string;

  const positionButtons: Record<PositionKey, PositionButtonCfg> = {
    'to-first':    { icon: <VerticalAlignTopOutlined />,    tooltip: 'to-first',    onClick: () => {} },
    'to-previous': { icon: <ArrowUpOutlined />,             tooltip: 'to-previous', onClick: () => {} },
    'to-next':     { icon: <ArrowDownOutlined />,           tooltip: 'to-next',     onClick: () => {} },
    'to-last':     { icon: <VerticalAlignBottomOutlined />, tooltip: 'to-last',     onClick: () => {} },
  };

  function takeRowData(): Item | null {
    // console.log("ROW sessionRow==== ", sessionRow);
    try {
    const sessionRow = sessionStorage.getItem("session_data_/directories/resolution-templates/executors");
    // console.log("ROW sessionRow==== ", sessionRow);

    if(!sessionRow) return null;

      const row = JSON.parse(sessionRow);
        return row;
    } catch (error) {
      console.error("Parse error PLACE!");
        return null;

    }

  }

  function setInMemory(valueArr: any){
    // const formValues = form.getFieldsValue();
    // const formArray: Item[] = formValues.resolutionData;
    // if(!formArray) return null;
    setContextTableData(valueArr)

  }

  function editingTableArray(id: number, tableCtx: Item[], position: string) {

    const i = tableCtx.findIndex(r => r.id === id);
    if(i<0) return tableCtx;

    if(position === positionsSelector.first){
      const copy = [...tableCtx];
      const[item] = copy.splice(i, 1);
      copy.unshift(item);
    
    return copy.map((it, idx)=> ({...it, num_pp: idx + 1}));
    }
    else
    if(position === positionsSelector.previous){
      if(i <= 0) return tableCtx;

      const copy = [...tableCtx];
      [copy[i - 1], copy[i]] = [copy[i], copy[i - 1]];
    
    return copy.map((it, idx)=> ({...it, num_pp: idx + 1}));
    }
    else
      if(position === positionsSelector.next){
        if(i >= tableCtx.length - 1) return tableCtx;

        const copy = [...tableCtx];
        [copy[i + 1], copy[i]] = [copy[i], copy[i + 1]];

        return copy.map((it, idx)=> ({...it, num_pp: idx + 1}));
      }
      else
        if(position === positionsSelector.last){
          if(i >= tableCtx.length - 1) return tableCtx;

          const copy = [...tableCtx];
          const [item] = copy.splice(i, 1);
          copy.push(item);

          return copy.map((it, idx)=> ({...it, num_pp: idx + 1}));
        }
    // console.log("Mapping Table Array ", mappingTableCtx);
  }


  function MoveRow(v: string) {
    // console.log("CONTEXT TABLE DATA ALL ", contextTableData);

    const arrCONTEXTTable: Item[] = [...contextTableData];

    const row: Item | null = takeRowData();

    if(!row) return null;
    const testArr = editingTableArray(row.id, arrCONTEXTTable, v);
    setInMemory(testArr);

    // console.log("ROW NEW==== ", testArr);
  };


   const updatePosition = async (v: string) => {
    switch (v) {
      case positionsSelector.first:
        return MoveRow(v);
      case positionsSelector.previous:
        return MoveRow(v);
      case positionsSelector.next:
        return MoveRow(v);
      case positionsSelector.last:
        return MoveRow(v);
      default:
        break;
    }
    // console.log("Position ", v);
    // const formValues = form.getFieldsValue();
    // console.log("Button  side form", formValues);
  };

    // console.log("PROPS URL STYLE ", props.url);

  const isEmployeesAndContactPers = pathname === "/directories/employees-and-contact-persons";
  const styleElectronicMail = pathname === "/documents/electronic-mail";
  const nomenclature = props.url === "/directories/structural-units";
  const isPassing = props.url === "/directories/discussion";


      const styleConfig = useMemo(() => {
      if (styleElectronicMail) return {display: "flex", height: "30px", width: "150px", alignItems: "center", justifyContent: "space-between", padding: "4px"};
      if (isEmployeesAndContactPers) return {display: "flex", height: "30px", width: "150px", alignItems: "start", justifyContent: "space-between", paddingTop: "10px"};
      if (nomenclature) return {display: "flex", height: "20px", width: "150px", alignItems: "start", justifyContent: "space-between", paddingTop: "10px"};
      if (isPassing) return {display: "flex", height: "30px", width: "70px", alignItems: "start", justifyContent: "space-between", paddingTop: "10px"};
    
    
      return {display: "flex", height: "30px", width: "150px", alignItems: "center", justifyContent: "space-between", padding: "4px"};
    }, [pathname]);

      const styleWrapp = useMemo(() => {
      if (styleElectronicMail) return {alignItems: "center"};
      if (isEmployeesAndContactPers) return {alignItems: "start", height: "fit-content"};
      if (nomenclature) return {alignItems: "center", height: "40px", width: "100%"};

    
    
      return {alignItems: "center", height: "63px", width: "100%"};
    }, [pathname]);

  return (
    <FormProvider>
      
      <Space className={styles["space"]}>

        <Space size={"middle"} align="start" style={styleWrapp}>
        <div className="MAINButtonsWrapper=====" style={styleConfig}>

            {props.url === "/directories/resolution-templates/executors" ? (
              <>
              {/* {console.log("PROPY MODAL ", props)} */}
              <Space>
                <Modal
                  // nameForButton='incoming-add'
                  name="add"
                  url="/directories/employees-and-contact-persons"
                  width={"auto"}
                >
                  <Directories
                    url="/directories/employees-and-contact-persons"
                    form={props.form}
                    allowMultiSelect={true}
                  />
                </Modal>
              </Space>

                {/* {Object.keys(positionButtons).map((item) => (
                  <Tooltip
                  key={item}
                    title={intl(`${positionButtons[item].tooltip}-position`)}
                  >
                    <Button
                      key={item}
                      className={styles["button"]}
                      disabled={disabled.edit}
                      // onClick={() => updatePosition(item)}
                    >
                      {positionButtons[item].icon}
                    </Button>
                  </Tooltip>
                ))} */}
                {Object.entries(positionButtons).map(([key, cfg]) => (
                  <Tooltip key={key} title={intl(`${cfg.tooltip}-position`)}>
                    <Button
                      className={styles["button"]}
                      disabled={disabled.edit}
                      onClick={() => updatePosition(key)} 
                    >
                      {cfg.icon}
                    </Button>
                  </Tooltip>
                ))}
              </>
            ) : pathname === "/directories/employees-and-contact-persons" ||
              pathname === "/directories/passing" ? (
                
            <Tooltip title={intl(`add`)}>       

            {/*==============Кнопка додавання employees-and-contact-persons=================*/}

              {dropdown}

            </Tooltip>
            ) : (
              flags.showAddButton && extraButtons.showAddButton
            )}

            {/* // Генерує список кнопок на основі умовних прапорів (flags).
            // З `flags` беруться лише ті, які не входять до списку `ignoredButtons`.
            // Для кожного прапора, що має значення `true`, відображається відповідна кнопка з `extraButtons`. 
            // Тут кнопки редагувати та видалити*/}
            {Object.entries(flags)
              .filter(([key]) => !ignoredButtons.includes(key))
              .map(
                ([key, value]) =>
                  value && <div key={key}>{extraButtons[key]}</div>
              )}
        </div>

          {isCheckboxGroup && <CheckboxGroup url={pathname} />}
          {isRadioGroup && <RadioGroup url={pathname} formName={formName} />}

        </Space>

        {isNomenclatureOfCases && <Select url={props.url} />}
      </Space>

      {/* {isCheckboxGroup && <CheckboxGroup url={pathname} formName={formName}/>} */}
      {/* {isRadioGroup && <RadioGroup url={pathname} formName={formName} />} */}
      <SignModal key="isSignFiles" name="isSignFiles" />
    </FormProvider>
  );
}
